import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * A password field with a show/hide button.
 *
 * Takes the same props as Input, so it can replace one directly. Typing a
 * password you cannot see is the most common cause of a failed login, and
 * people set weaker passwords when they cannot check what they typed.
 */
const PasswordInput = ({ className = '', ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? 'text' : 'password'}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        // Excluded from tab order: it is a convenience, and stopping between
        // the password field and the submit button to skip past it is not.
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-[#5C665F] hover:text-[#1A231C] transition-colors"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};

export default PasswordInput;
